module.exports = __webpack_public_path__ + "img/beijing_zuo.b960380b.png";